import React from "react";
import { BusinessCreditReportStatePII, IUniformCommercialCodeFining } from "../../../../store/businessCreditReportService/types";
import { toggle } from "../../../../util/common";

interface IProps {
    reportObject: BusinessCreditReportStatePII;
    showAsAccordion?: boolean;
}
const LegalFilingsUccFilings: React.FunctionComponent<IProps> = (props) => {
    return (
        <React.Fragment>
            <div role="listitem" className="data-row">
                <div className="link-item">
                    {props.showAsAccordion ? (
                        <button
                            type="button"
                            aria-expanded="false"
                            className="link-button"
                            id="btn-leagal-filings-ucc"
                            onClick={(e) => toggle("leagal-filings-ucc-div", "btn-leagal-filings-ucc")}
                        >
                            <span className="row link-item">
                                <span className="col-xs col-no-gutter link-text">
                                    <span className="link-title">
                                        <span className="btn-toggle-status sr-only">Show</span> UCC Filings
                                    </span>
                                </span>
                            </span>
                        </button>
                    ) : (
                        <h5 className="report-sub-title">UCC Filings</h5>
                    )}

                    <div
                        className="wallet-details"
                        id="leagal-filings-ucc-div"
                        style={{ ...(props.showAsAccordion ? { display: "none" } : {}) }}
                        aria-hidden="true"
                    >
                        {props.reportObject?.businessCompanyReport?.uniform_commercial_code_finings?.map(
                            (uccFiling: IUniformCommercialCodeFining, index: number) => (
                                <React.Fragment key={`active-lawsuite-${index}`}>
                                    <div role="grid" className="data-grid row-height-xs " aria-labelledby="btn-leagal-filings-ucc">
                                        <div role="row" className="data-row condensed row">
                                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                                <div className="data-label" id={`leagal-filings-ucc-date-filed-${index}`}>
                                                    Date Filed
                                                </div>
                                            </div>
                                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                                <div className="data-label" id={`leagal-filings-ucc-expiration-date-${index}`}>
                                                    Expiration Date
                                                </div>
                                            </div>
                                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                                <div className="data-label" id={`leagal-filings-ucc-filing-number-${index}`}>
                                                    Filing Number
                                                </div>
                                            </div>
                                        </div>

                                        <div role="row" className="data-row condensed row">
                                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                                <div className="data-value" aria-labelledby={`leagal-filings-ucc-date-filed-${index}`}>
                                                    {uccFiling?.date_filed}
                                                </div>
                                            </div>
                                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                                <div className="data-value" aria-labelledby={`leagal-filings-ucc-expiration-date-${index}`}>
                                                    {uccFiling?.expiration_date}
                                                </div>
                                            </div>
                                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                                <div className="data-value" aria-labelledby={`leagal-filings-ucc-filing-number-${index}`}>
                                                    {uccFiling?.filing_number}
                                                </div>
                                            </div>
                                        </div>

                                        <div role="row" className="data-row condensed row">
                                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                                <div className="data-label" id={`leagal-filings-ucc-jurisdiction-${index}`}>
                                                    Jurisdiction
                                                </div>
                                            </div>
                                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                                <div className="data-label" id={`leagal-filings-ucc-collateral-${index}`}>
                                                    Collateral
                                                </div>
                                            </div>
                                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                                <div className="data-label" id={`leagal-filings-ucc-status-${index}`}>
                                                    Status
                                                </div>
                                            </div>
                                        </div>

                                        <div role="row" className="data-row condensed row">
                                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                                <div className="data-value" aria-labelledby={`leagal-filings-ucc-jurisdiction-${index}`}>
                                                    {uccFiling?.jurisdiction}
                                                </div>
                                            </div>
                                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                                <div className="data-value" aria-labelledby={`leagal-filings-ucc-collateral-${index}`}>
                                                    {uccFiling?.collateral}
                                                </div>
                                            </div>
                                            <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                                <div className="data-value" aria-labelledby={`leagal-filings-ucc-status-${index}`}>
                                                    {uccFiling?.status}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )
                        )}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default LegalFilingsUccFilings;
